export interface ValidationErrorsProps {
  ENDERECO?: number;
  DADOS_BANCARIOS?: number;
  GENERIC?: number;
}

export const validationErrorsMap = new Map([
  ["ENDERECO", "Endereço"],
  ["GENERIC", "Outros"],
  ["DADOS_BANCARIOS", "Dados bancários"],
]);

export * from "./pipeline";
